import styled from 'styled-components';

import InputSimple from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const BasePopup = styled(DefaultPopup)`
    padding: 32px;

    &>div:first-child {
        float: right;
        position: relative;
        top: 0;
        right: 0;
        margin-left: 10px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 24px;
        width: 343px !important;
    }
`;

export const ConfirmRadioBlock = styled.div`
    flex-direction: column;
    margin-bottom: 24px;
`;

export const ConfirmationTitle = styled.div`
    ${FONTS.H3};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const ConfirmRadios = styled.div`
    flex-wrap: nowrap;
    column-gap: 16px;
`;

export const SmsInputsWrap = styled.div`
    flex-direction: column;
    align-items: flex-start;
    margin-top: 8px;
    margin-bottom: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: row;
        margin-top: 12px;
    }
`;

export const SmsInput = styled(InputSimple)`
    margin-bottom: 0;

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: 100%;
    }
`;

export const SmsTextNumber = styled.span`
    white-space: pre;
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};
`;

export const BtnWrap = styled.div`
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: ${wideBreakpoints.mobile}) {
        align-items: stretch;
    }
`;
